import styled from "styled-components"

const BlogPostsWrapper = styled.div`
  margin: 0 auto;
  padding-top: 50px;
  position: relative;
  .post_card {
    margin-bottom: 20px;
    @media (max-width: 990px) {
      margin-bottom: 15px;
    }
    @media (max-width: 575px) {
      margin-bottom: 10px;
    }
  }
  .post_preview3 {
    margin-top: 0;
    @media (min-width: 991px) {
      flex: 0 0 35%;
      max-width: 35%;
      padding-left: 60px;
      margin: 0;
      display: inline;
      &:before {
        width: calc(80% - 60px);
      }
    }
  }
  .post_des_wrapper3 {
    @media (min-width: 991px) {
      flex: 0 0 65%;
      max-width: 65%;
      margin: 0;
      display: inline;
    }
    .post_des {
      margin-top: 60px;
    }
  }
`

export const PostSection1 = styled.div`
  margin-top: 0;
  @media (min-width: 991px) {
    flex: 0 0 50%;
    max-width: 50%;
    padding-left: 20px;
    margin: 0;
    display: inline;
    &:before {
      width: calc(80% - 60px);
    }
  }
  @media (max-width: 990px) {
    flex: 0 0 100%;
    width: 100%;
  }

`;
export const PostSection2 = styled.div`
@media (min-width: 991px) {
  flex: 0 0 50%;
  max-width: 50%;
  margin: 0;
  display: inline;
}
@media (max-width: 990px) {
  flex: 0 0 100%;
  width: 100%;
}
.post_des {
  margin-top: 60px;
}

`;
export default BlogPostsWrapper
